import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonStandaloneModule } from '../../../../common-standalone.module';
import { MatInputModule } from '@angular/material/input';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { ServiceTicket, ServiceTicketStore } from '../../../../../@store';

@Component({
  selector: 'app-service-ticket-feedback',
  standalone: true,
  imports: [
    CommonStandaloneModule,
    MatInputModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  templateUrl: './service-ticket-feedback.component.html',
  styleUrls: ['./service-ticket-feedback.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceTicketFeedbackComponent implements OnInit, OnDestroy {
  additionalFeedback = '';
  minFeedbackLength = 20;

  feedbackValueChanged$ = new Subject<string>();
  private ngUnsubscribe$ = new Subject<void>();

  constructor(public serviceTicketStore: ServiceTicketStore, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.serviceTicketStore.activePage$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((activePage) => {
        if (
          activePage === ServiceTicket.ServiceTicketPage.Call &&
          this.additionalFeedback.length >= 20
        ) {
          this.serviceTicketStore.updateFeedback(this.additionalFeedback);
          this.cdr.markForCheck();
        }
      });
    this.feedbackValueChanged$
      .pipe(debounceTime(1000), takeUntil(this.ngUnsubscribe$))
      .subscribe((feedback) => {
        this.serviceTicketStore.updateFeedback(feedback);
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  onInputValueChange(event: Event): void {
    const text = (event.target as HTMLInputElement).value;
    this.additionalFeedback = text;
    this.feedbackValueChanged$.next(text);
    this.cdr.markForCheck();
  }
}
